import React, { useState, useEffect } from 'react';
import { getSwitchboards } from '../../api/switchboards';

const byName = (a, b) => (a.name || '').localeCompare(b.name || '', undefined, { numeric: true });

// Switchboards of a project plus the selected one, remembered per project (shared by all reports)
export default function useSwitchboardPicker(project) {
  const storageKey = `report_sb_${project?._id}`;
  const [switchboards, setSwitchboards] = useState([]);
  const [selectedId, setSelectedId] = useState(() => {
    try { return localStorage.getItem(storageKey) || ''; } catch { return ''; }
  });

  useEffect(() => {
    if (!project?._id) return;
    getSwitchboards(project._id).then(r => {
      const list = [...r.data].sort(byName);
      setSwitchboards(list);
      setSelectedId(id => (list.some(s => s._id === id) ? id : list[0]?._id || ''));
    }).catch(() => {});
  }, [project?._id]);

  const select = (id) => {
    setSelectedId(id);
    try { localStorage.setItem(storageKey, id); } catch {}
  };

  const selected = switchboards.find(s => s._id === selectedId) || null;
  return { switchboards, selected, select };
}

export function SwitchboardSelect({ switchboards, selected, select }) {
  return (
    <select className="report-sb-select" value={selected?._id || ''} onChange={e => select(e.target.value)}>
      {switchboards.length === 0 && <option value="">No switchboards</option>}
      {switchboards.map(s => <option key={s._id} value={s._id}>{s.name}{s.description ? ` — ${s.description}` : ''}</option>)}
    </select>
  );
}
